import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { EquipementService } from 'src/app/_services/equipement.service';

@Component({
  selector: 'app-equipements',
  templateUrl: './equipements.component.html',
  styleUrls: ['./equipements.component.scss']
})
export class EquipementsComponent implements OnInit {
  equipements: any
  constructor(private equipementService: EquipementService,private titleService: Title) { }

  ngOnInit(): void {
    this.getEquipements();
    this.titleService.setTitle("Équipements Communaux")
  }

  getEquipements(){
    this.equipementService.getAll().subscribe(data => {
      this.equipements = data.data;
    })
  }
}
